<template>
  <div style='width: 100%;'>
    <div class='sdau_search'>
      <el-form ref="form" :model="formData" label-width="100px" :inline="true">
        <el-row>
          <el-col :span='8'>
            <el-form-item label="考核日期">
              <el-date-picker @change="handleTimeuse" v-model="dateRangeuse" size="small" value-format="yyyy-MM-dd"
                type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="截止日期"
                clearable></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span='8'>
            <el-form-item label="考核结果">
              <el-select v-model="formData.isPassed" placeholder="请选择考核结果">
                <el-option label="全部" value=""></el-option>
                <el-option label="合格" value="1"></el-option>
                <el-option label="不合格" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='8'>
            <el-form-item label="试卷分类">
              <el-select v-model="formData.testPaperTypeId" placeholder="请选择试卷分类">
                <el-option v-for='(item, index) in typeData' :key='index' :label="item.dictLabel"
                  :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='8'>
            <el-form-item label="设备名称">
              <el-input placeholder="请输入设备名称" v-model="formData.equipmentName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='8'>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索
            </el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="e_reset">重置 </el-button>
          </el-col>

        </el-row>

      </el-form>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column type="index" :index='Nindex' width="55" label="序号" align="center">
      </el-table-column>
      <el-table-column prop="testPaperCode" width="100" label="试卷编号" align="center">
      </el-table-column>
      <el-table-column prop="testPaperTypeId" width="100" label="试卷分类" align="center">
        <template slot-scope="scope">
          <div v-for="(item, i) in typeData" :key="i + 'testPaperTypeId'">
            <span v-if="scope.row.testPaperTypeId == item.dictCode">{{ item.dictLabel }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="testPaperName" width="100" label="试卷名称" align="center">
      </el-table-column>
      <el-table-column prop="minSubject" width="100" label="题目数量" align="center">
      </el-table-column>
      <el-table-column prop="totalScore" width="140" label="满分" align="center">
      </el-table-column>
      <el-table-column prop="passScore" width="140" label="及格线" align="center">
      </el-table-column>
      <el-table-column prop="answerTime" width="140" label="考核日期" align="center">
      </el-table-column>
      <el-table-column prop="achievement" width="140" label="考分" align="center">
      </el-table-column>
      <el-table-column prop="isPassed" width="140" label="判定结果" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.isPassed == 0">不合格</span>
          <span v-if="scope.row.isPassed == 1">合格</span>
        </template>
      </el-table-column>
      <el-table-column prop="reservationStartTime" width="140" label="关联设备" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showSeteqment(scope.row.appraisalTestPaperId)">{{
            scope.row.equipmentName }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination v-show="total > 0" :pageSizes="pageSizes" :total="total" :page.sync="formData.pageNum"
      :limit.sync="formData.pageSize" @pagination='init' />
    <seteqmentTable v-if='showEqment' :showEqment='showEqment' :appraisalTestPaperId='appraisalTestPaperId'
      @cancel='showEqment = false' />
  </div>
</template>
<script>
import seteqmentTable from './seteqmentTable.vue'
export default {
  props: {},
  components: {
    seteqmentTable
  },
  data() {
    return {
      formData: {
        pageNum: 1,
        pageSize: 5,
      },
      total: 1,
      pageSizes: [5, 10, 20, 50, 100, 300],
      tableData: [],
      typeData: [],
      dateRangeuse: [],
      showEqment: false,
      appraisalTestPaperId: ''
    }
  },
  methods: {
    handleQuery() {
      this.formData.pageNum = 1
      this.init()
    },
    e_reset() {
      this.formData = {
        pageNum: this.formData.pageNum,
        pageSize: this.formData.pageSize,
      }
      this.dateRangeuse = []
      this.init()
    },

    handleTimeuse(date) {
      if (date) {
        this.formData.startDate = date[0]
        this.formData.endDate = date[1]
      } else {
        this.formData.startDate = []
        this.formData.endDate = []
      }
    },
    Nindex(index) {
      const page = this.formData.pageNum
      const pagesize = this.formData.pageSize
      return index + 1 + (page - 1) * pagesize
    },
    showSeteqment(id) {
      this.showEqment = true
      this.appraisalTestPaperId = id
    },
    init() {
      this.$net('/system/dict/data/type/classification_test_papers', 'get').then(res => {
        this.typeData = res.data
      })
      this.$net('/sdau/userClient/appraisalResult/resultList', 'get', this.formData).then(res => {
        this.tableData = res.data.list
      })
    },

    appointagain(row) {
      this.$router.push({
        path: '/appointment',
        query: {
          id: row.equipmentId
        }
      })
    },


  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-table th {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #666666;
}

::v-deep .el-table td {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #333333;
}

.eq_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>